module.exports = __webpack_public_path__ + "img/cd23ef1.jpg";